import signIcon from './signIcon.svg';
import gateController from './gateController.svg';
import gateControllerWhite from './gateControllerWhite.svg';
import connectedVehicleIcon from './connectedVehicleIcon.svg';
import rampMeterIcon from './rampMeterIcon.svg';
import tunnelIcon from './tunnelIcon.svg';
import tollingPoint from './tollingPointIcon.svg';

const icons = {
  gateController,
  gateControllerWhite,
  signIcon,
  connectedVehicleIcon,
  rampMeterIcon,
  tunnelIcon,
  tollingPoint,
};

export default icons;
